module.exports = __webpack_public_path__ + "images/banners/pages_iphone/iphone-page-mock1_01e4a1503598f10dd4f0451672eb9703.png";